import { ListTodo } from 'lucide-react';
import PageHeader from '../../components/PageHeader';
import FollowUpsBoard from '../../components/sales/FollowUpsBoard';
import { useCrmSeat } from '../../hooks/useCrmSeat';
import { useOrgTimezone } from '../../utils/timezone';

/**
 * /sales/follow-ups: every follow-up and issue, for a Sales seat or a
 * Nursery operator and up (`useCrmSeat`), who has no way into /sales. Where
 * a Sales notification about a follow-up or issue opens.
 */
export default function FollowUps() {
  const tz = useOrgTimezone();
  const { hasAccess } = useCrmSeat();
  return (
    <>
      <PageHeader title="Follow-ups and issues" subtitle="What to do for customers, and what went wrong with orders and loads"
        icon={<ListTodo className="h-6 w-6 text-white" />} />
      <div className="max-w-5xl mx-auto px-4 py-6">
        {hasAccess && <FollowUpsBoard tz={tz} />}
      </div>
    </>
  );
}
